"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var Metadata = function Metadata(props) {
  var categoriesCount = props.categoriesCount,
      totalTopicCount = props.totalTopicCount;
  if (!categoriesCount && !totalTopicCount) return null;
  return (0, _preact.h)("ul", {
    className: "list--dot-seperated knowledge-base__card-metadata"
  }, categoriesCount > 0 && (0, _preact.h)("li", {
    className: "qa-forum-overview-category-counter"
  }, categoriesCount, " ", (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "knowledgebase.category",
    count: {
      n: categoriesCount.toString()
    }
  })), totalTopicCount > 0 && (0, _preact.h)("li", {
    className: "qa-forum-overview-post-counter"
  }, (0, _preact.h)(_phrase.default, {
    m: "Common",
    p: "knowledge.base.articles",
    count: {
      n: totalTopicCount.toString()
    }
  })));
};

var _default = Metadata;
exports.default = _default;